export default "__VITE_ASSET__Bz87i07t__"